// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__E1V5x","requiredAsterisk":"Info_requiredAsterisk__12tg-"};